import type { Environment } from './environment.model';

/** Entorno develop. Comandos: `pnpm develop` y `pnpm serve:dev`. */
export const environment: Environment = {
  name: 'develop',
  production: false,
  apiUrl: 'https://dealers-back-dev.bshouse.io/credit-request-service',
  appUrl: 'https://landing-dev.bshouse.io',
};
